import { StepperContextData } from '../contexts';

export const isMultidoor = (stepperData: StepperContextData) => {
  const { isParallel, multiDoor } = stepperData;
  return !!multiDoor && !isParallel;
};